export class PatientFileUploader {
    constructor(id, run, uploadedBy, origin) {
        this.run = run;
        this.origin = origin;
        this.id = id;
        this.uploadedBy = uploadedBy;
    }
    getId() {
        return this.id;
    }
    getRun() {
        return this.run;
    }
    getUploadedBy() {
        return this.uploadedBy;
    }
    getOrigin() {
        return this.origin;
    }
    getName() {
        return `captura-vc_${this.getId()}_${this.getUploadedBy()}`;
    }
    async upload(file, name) {
        const info = {
            url: `static/repository/patients/${this.run}`,
            name
        };
        const formData = new FormData();
        //@ts-ignore
        formData.append("file", file, name);
        const uploadResponse = await fetch(`${this.origin}file/repository/patients/${this.run}`, {
            method: "POST",
            body: formData,
            credentials: 'include',
        });
        if (!uploadResponse.ok) {
            throw new Error(`Error al subir el archivo: ${uploadResponse.statusText}`);
        }
        const uploadResponseJson = await uploadResponse.json();
        const infoResponse = await fetch(`${this.origin}file/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(info),
            credentials: 'include'
        });
        if (!infoResponse.ok) {
            throw new Error(`Error al guardar la información: ${infoResponse.statusText}`);
        }
        const resultData = await infoResponse.json();
        return uploadResponseJson.result;
    }
    async create(fileTypeId, name) {
        const info = {
            patient_id: this.id,
            file_type_id: fileTypeId,
            uploaded_by: this.uploadedBy,
            file_name: name,
            url: `static/repository/patients/${this.run}`
        };
        const response = await fetch(`${this.origin}complementary-exams/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(info),
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status} - ${response.statusText}`);
        }
        const data = await response.json();
        return { data };
    }
    async handle(file, fileTypeId, name) {
        const filename = await this.upload(file, name);
        const data = await this.create(fileTypeId, filename);
        return data;
    }
}
// function getFormattedDate() {
//     const date = new Date();
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     const hours = String(date.getHours()).padStart(2, '0');
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const seconds = String(date.getSeconds()).padStart(2, '0');
//     return `${year}-${month}-${day}_${hours}:${minutes}:${seconds}`;
// }
